import $ from 'jquery';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import { MdClose } from 'react-icons/md';
import i18n from '../../i18next';

let unique = -1;

export const ShowAlertPopUp = (message, callback) => {
	return showPopUp(
		i18n.t('alert'),
		message,
		<button
			type="button"
			className="button yes"
		>
			{ i18n.t('ok') }
		</button>,
		callback
	);
}

export const ShowSaveCancelPopUp = (title, message, callback, extraClass = '') => {
	return showPopUp(
		title,
		message,
		<Fragment>
			<button
				type="button"
				className="button yes"
			>
				{ i18n.t('save') }
			</button>
			<button
				type="button"
				className="button no"
			>
				{ i18n.t('cancel') }
			</button>
		</Fragment>,
		callback,
		extraClass
	);
}

export const ShowCustomPopupBox = (title, message, callback, extraClass = '') => {
	return showPopUp(
		title,
		message,
		<button
			type="button"
			className="button yes"
		>
			{ i18n.t('ok') }
		</button>,
		callback,
		extraClass
	);
}

export const ShowConfirmPopUp = (message, callback, extraClass = '') => {
	return showPopUp(
		i18n.t('confirm'),
		message,
		<Fragment>
			<button
				type="button"
				className="button yes"
			>
				{ i18n.t('yes') }
			</button>
			<button
				type="button"
				className="button no"
			>
				{ i18n.t('no') }
			</button>
		</Fragment>,
		callback,
		extraClass
	);
}

export const ShowInfoPopUp = (message, callback, extraClass = '') => {
	return showPopUp(
		i18n.t('information'),
		message,
		<button
			type="button"
			className="button yes"
		>
			{i18n.t('ok')}
		</button>,
		callback,
		extraClass
	);
}

export const ShowPopupWithoutButtons = (title, message, callback, extraClass = '') => {
	return showPopUp(
		title,
		message,
		'',
		callback,
		extraClass
	);
}

export const ShowInfoTitlePopUp = (title, message, callback, extraClass = '') => {
	return showPopUp(
		title,
		message,
		<button
			type="button"
			className="button yes"
		>
			{ i18n.t('ok') }
		</button>,
		callback,
		extraClass
	);
}

export const showPopUp = (title, message, extra, callback, extraClass = '', opened) => {
	let win = $('<div />');
	let callbackCalled = false;
	let section = $('div.main > section')
	let winContainer = $('<div />')

	win.append(winContainer)

	$('body').append(win);

	if(!extra) {
		extra = '';
	}

	if(section.length > 0) {
		extraClass += ` ${section.attr("class")}-popup`
	}

	const root = ReactDOM.createRoot(winContainer[0]);

	root.render(<div
		id={ `react-popup-${unique--}`}
		className={`row reveal popupbox ${extraClass}` }
		style={{ display: 'block'}}
	>
		<div className="title">
			<b className="title-name">{ title }</b>
			<MdClose
				title="Close"
				className="close-icon float-right no"
			/>
		</div>
		<div className="message">
			{ message }
		</div>
		<span className="button-group">
			{ extra }
		</span>
	</div>);

	win.on("click", ".yes", function(event) {
		var skipClose = false;

		if(callback != undefined) {
			skipClose = callback(true, $(event.target), win);
			callbackCalled = true;
		}

		if(!skipClose) {
			win.foundation('close');
			$('body.is-reveal-open').removeClass('is-reveal-open')
		}
	});

	win.on("click", ".no", function(event) {
		var skipClose = false;

		if(callback != undefined) {
			skipClose = callback(false, $(event.target), win);
			callbackCalled = true;
		}

		if(!skipClose) {
			$('body.is-reveal-open').removeClass('is-reveal-open')
			win.foundation('close');
		}
	});

	// eslint-disable-next-line
	var elem = new window.Foundation.Reveal(win, {
		'animationIn': 'hinge-in-from-middle-x fast',
		'animationOut': 'hinge-out-from-middle-y fast',
		'resetOnClose': true,
		'closeOnEsc': true,
		'closeOnClick': true,
		'deepLink': false,
		'multipleOpened': true,
	});

	// eslint-disable-next-line
	win.on('closed.zf.reveal', function(e) {
		var _this = $(this);

		if(callback != undefined && !callbackCalled) {
			callback(false);
		}

		_this.foundation('destroy');
		_this.remove();
		$('body.is-reveal-open').removeClass('is-reveal-open')
	});

	win.close = () => win.find(".no").click()
	win.forceClose = () => {
		win.foundation('close')
		$('body.is-reveal-open').removeClass('is-reveal-open')
	}

	win.foundation('open');

	if(opened) {
		opened()
	}

	return win;
}
